export var PublisherStatusType;
(function (PublisherStatusType) {
    PublisherStatusType[PublisherStatusType["POPULAR"] = 1] = "POPULAR";
    PublisherStatusType[PublisherStatusType["ONLINE"] = 2] = "ONLINE";
    PublisherStatusType[PublisherStatusType["IN_MAINTENANCE"] = 3] = "IN_MAINTENANCE";
    PublisherStatusType[PublisherStatusType["NOT_SALE"] = 4] = "NOT_SALE";
    PublisherStatusType[PublisherStatusType["REMOVED"] = 5] = "REMOVED";
})(PublisherStatusType || (PublisherStatusType = {}));
//# sourceMappingURL=PublisherStatusType.js.map